import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import iptrackerdetails from '../../../iptrackerdetails'
import VueElementLoading from 'vue-element-loading';
import {
  Validator
} from 'vee-validate'

export default {
  name: 'dashboard',
  components: {
    VueElementLoading
  },
  props: [],
  data() {
    return {
      localuserid: 0,
      show:'',
      projects:[],
    }
  },
  computed: {

  },
  mounted() {

    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.iptrackData = userdetail;
    iptrackerdetails.checkUserIP(this.iptrackData,'Dashboard',this.$route.path);
    this.localuserid = userdetail.userid;
    this.username = userdetail.username;

    this.getUserAccessData();
    //this.redirectToLogin();
  },
  methods: {
    getUserAccessData() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');

      this.input = ({
          userid: this.localuserid
          //userid: 40010
      })

      this.show = true;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'userAppAccessDetails',
          'data': this.input,
          headers: {
              'Authorization': 'Bearer ' + myStr
          }
      })
      .then(async result => {
        this.projects = result.data;
        this.show = false;
      }, error => {
          console.error(error)
      })
    },
    redirectToLogin(projectUrl, project){
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      let url = apiUrl.api_url + 'googlelogin/GetToken';
      let encryPassword = window.localStorage.getItem('encryPassword')
      this.input = {
        "username": this.username,
        "projectid": project
      }
      if(encryPassword != 'undefined'){
        this.input.password = encryPassword;
        url = apiUrl.api_url + 'GetUserEncryptToken';
      }
      this.show = true;
      axios({
          method: 'POST',
          'url': url,
          'data': this.input,
          headers: {
              'Authorization': 'Bearer ' + myStr
          }
      })
      .then(result => {
        if(result.data.code == 200)
        {
          window.open(projectUrl+'/'+result.data.token, '_blank')
        }
        this.show = false;
      }, error => {
          console.error(error)
      })

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/dashboard/dashboard.component.js